import { FC } from 'react';

// MUI
import TextField, { TextFieldProps } from '@mui/material/TextField';

// Third party
import { Controller, useFormContext } from 'react-hook-form';

type TRHFTextField = TextFieldProps & {
  name: string;
};

const RHFTextField: FC<TRHFTextField> = ({
  name, helperText, type, placeholder, label, autoComplete = 'off', sx, inputProps, ...other
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          autoComplete={autoComplete}
          slotProps={{
            input: {
              autoComplete: autoComplete,
              inputProps: { maxLength: 225, ...inputProps },
            }
          }}
          sx={sx}
          label={label}
          placeholder={placeholder}
          {...field}
          fullWidth
          type={type}
          value={type === 'number' ? (field.value === 0 || field.value === '' || field.value === null || field.value === undefined ? 0 : field.value) : (field.value ?? '')}
          onChange={(event) => {
            if (type === 'number') {
              const value = event.target.value;
              if (value === '' || value === null || value === undefined) {
                field.onChange(0);
              } else {
                const numValue = Number(value);
                field.onChange(isNaN(numValue) ? 0 : numValue);
              }
            } else if (type === 'tel') {
              const sanitized = event.target.value.replace(/[^0-9+\-() ]/g, '');
              field.onChange(sanitized);
            } else {
              field.onChange(event.target.value);
            }
          }}
          error={!!error}
          helperText={error ? error?.message: helperText}
          {...other}
        />
      )}
    />
  );
};

export {
  RHFTextField,
};
